export const faBenchmark = {
    prefix: "far",
    iconName: "benchmark",
    icon: [512, 384, [], "f142", "M502,159.57H10a10,10,0,0,0-10,10v10a10,10,0,0,0,10,10H39.5V318.45a10,10,0,0,0,10,10h10a10,10,0,0,0,10-10V189.57h374V316.45a12,12,0,0,0,12,12h6a12,12,0,0,0,12-12V189.57H502a10,10,0,0,0,10-10v-10A10,10,0,0,0,502,159.57ZM463,38.26c1,3,.57,5.43-.93,"
    + "5.88s-186.42,67.64-186.42,67.64c-2.31,1-5.62,3.17-8.76,0L206.19,39,89.64,113a6.29,6.29,0,0,1-8.76.31L68.68,97.1a6.29,6.29,0,0,1-.31-8.76L200.59,3.71C209.71-1,214.35-1,217.71,2.58l61.35,70.63S444.81,12,447.13,11.34s3.78-.51,4.64,1.55Z"]
};
